import { Fragment } from "react";
import { 
    ControllerHeroContainer, 
    ControllerInfoContainer,
    InvitationCardContent
} from "./CardContent";


function ControllerCard({ date_created, group_name, product, tags, OpenGame, createdBy, user }) {
    return (
        <Fragment>
            <div className="flex-1 grid grid-rows-2 lg:grid-cols-3 lg:grid-rows-none m-5 bg-coolGray-50 rounded shadow-2xl min-w-1/3">
            <ControllerHeroContainer date_created={date_created} group_name={group_name} tags={tags} OpenGame={OpenGame} product={product} user={user} createdBy={createdBy} />
            <ControllerInfoContainer date_created={date_created} group_name={group_name} images={product.game_image} product={product} user={user} createdBy={createdBy}/>
            </div>
        </Fragment>
    )
}

function InviteCard({ connected }) {
    return (
        <Fragment>
            <div className="flex-1 p-5 m-5 bg-coolGray-50 rounded-xl shadow-xl">
                <InvitationCardContent connected={connected}/>
            </div>
        </Fragment>
    )
}

export { ControllerCard, InviteCard }
